module.exports = __webpack_public_path__ + "static/media/27OCHA9.d3cd2745.jpg";